import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { LogoMark } from "@/components/site/Logo";
import { useSeo } from "@/lib/seo";

export default function AdminLogin() {
  useSeo({ title: "Connexion admin | Ozentya", noindex: true });
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.token) localStorage.setItem("ozy_admin_token", data.token);
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setLoading(false);
    }
  };

  const field = "h-12 w-full rounded-sm border border-[var(--line)] bg-transparent px-4 text-sm outline-none focus:border-[var(--gold)]";
  return (
    <main data-testid="admin-login-page" className="grain relative flex min-h-screen items-center justify-center bg-[radial-gradient(ellipse_at_top,#2a0f27,#0b0809_70%)] px-5">
      <form onSubmit={submit} className="relative w-full max-w-sm rounded-sm border border-[var(--line)] bg-[rgba(11,8,9,0.7)] p-10 backdrop-blur-xl">
        <LogoMark className="h-12 w-12" />
        <p className="eyebrow mt-8">Espace admin</p>
        <h1 className="mt-2 font-display text-4xl italic">Connexion</h1>
        <div className="mt-8 space-y-4">
          <input data-testid="admin-login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
          <input data-testid="admin-login-password" type="password" required placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} className={field} />
        </div>
        {err && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{err}</p>}
        <button data-testid="admin-login-submit" disabled={loading} className="mt-8 flex h-12 w-full items-center justify-center gap-2 rounded-full bg-[var(--gold)] text-xs font-semibold uppercase tracking-[0.24em] text-[var(--ink)] hover:bg-[var(--gold-soft)] disabled:opacity-50">
          {loading && <Loader2 className="h-4 w-4 animate-spin" />} Se connecter
        </button>
      </form>
    </main>
  );
}
